import { useState, useRef, useEffect } from 'react';
import { initI18n, useTranslation } from '../../shared/i18n/index';
import { NeedHelp } from '../../shared/components/NeedHelp';

// Time zone list - same as Rails ActiveSupport::TimeZone
const TIME_ZONES = [
  { value: 'International Date Line West', label: '(GMT-12:00) International Date Line West' },
  { value: 'American Samoa', label: '(GMT-11:00) American Samoa' },
  { value: 'Midway Island', label: '(GMT-11:00) Midway Island' },
  { value: 'Hawaii', label: '(GMT-10:00) Hawaii' },
  { value: 'Alaska', label: '(GMT-09:00) Alaska' },
  { value: 'Pacific Time (US & Canada)', label: '(GMT-08:00) Pacific Time (US & Canada)' },
  { value: 'Tijuana', label: '(GMT-08:00) Tijuana' },
  { value: 'Arizona', label: '(GMT-07:00) Arizona' },
  { value: 'Chihuahua', label: '(GMT-07:00) Chihuahua' },
  { value: 'Mazatlan', label: '(GMT-07:00) Mazatlan' },
  { value: 'Mountain Time (US & Canada)', label: '(GMT-07:00) Mountain Time (US & Canada)' },
  { value: 'Central America', label: '(GMT-06:00) Central America' },
  { value: 'Central Time (US & Canada)', label: '(GMT-06:00) Central Time (US & Canada)' },
  { value: 'Guadalajara', label: '(GMT-06:00) Guadalajara' },
  { value: 'Mexico City', label: '(GMT-06:00) Mexico City' },
  { value: 'Monterrey', label: '(GMT-06:00) Monterrey' },
  { value: 'Saskatchewan', label: '(GMT-06:00) Saskatchewan' },
  { value: 'Bogota', label: '(GMT-05:00) Bogota' },
  { value: 'Eastern Time (US & Canada)', label: '(GMT-05:00) Eastern Time (US & Canada)' },
  { value: 'Indiana (East)', label: '(GMT-05:00) Indiana (East)' },
  { value: 'Lima', label: '(GMT-05:00) Lima' },
  { value: 'Quito', label: '(GMT-05:00) Quito' },
  { value: 'Atlantic Time (Canada)', label: '(GMT-04:00) Atlantic Time (Canada)' },
  { value: 'Caracas', label: '(GMT-04:00) Caracas' },
  { value: 'Georgetown', label: '(GMT-04:00) Georgetown' },
  { value: 'La Paz', label: '(GMT-04:00) La Paz' },
  { value: 'Puerto Rico', label: '(GMT-04:00) Puerto Rico' },
  { value: 'Santiago', label: '(GMT-04:00) Santiago' },
  { value: 'Newfoundland', label: '(GMT-03:30) Newfoundland' },
  { value: 'Brasilia', label: '(GMT-03:00) Brasilia' },
  { value: 'Buenos Aires', label: '(GMT-03:00) Buenos Aires' },
  { value: 'Greenland', label: '(GMT-03:00) Greenland' },
  { value: 'Montevideo', label: '(GMT-03:00) Montevideo' },
  { value: 'Mid-Atlantic', label: '(GMT-02:00) Mid-Atlantic' },
  { value: 'Azores', label: '(GMT-01:00) Azores' },
  { value: 'Cape Verde Is.', label: '(GMT-01:00) Cape Verde Is.' },
  { value: 'Dublin', label: '(GMT+00:00) Dublin' },
  { value: 'Edinburgh', label: '(GMT+00:00) Edinburgh' },
  { value: 'Lisbon', label: '(GMT+00:00) Lisbon' },
  { value: 'London', label: '(GMT+00:00) London' },
  { value: 'Monrovia', label: '(GMT+00:00) Monrovia' },
  { value: 'UTC', label: '(GMT+00:00) UTC' },
  { value: 'Amsterdam', label: '(GMT+01:00) Amsterdam' },
  { value: 'Belgrade', label: '(GMT+01:00) Belgrade' },
  { value: 'Berlin', label: '(GMT+01:00) Berlin' },
  { value: 'Bern', label: '(GMT+01:00) Bern' },
  { value: 'Bratislava', label: '(GMT+01:00) Bratislava' },
  { value: 'Brussels', label: '(GMT+01:00) Brussels' },
  { value: 'Budapest', label: '(GMT+01:00) Budapest' },
  { value: 'Casablanca', label: '(GMT+01:00) Casablanca' },
  { value: 'Copenhagen', label: '(GMT+01:00) Copenhagen' },
  { value: 'Ljubljana', label: '(GMT+01:00) Ljubljana' },
  { value: 'Madrid', label: '(GMT+01:00) Madrid' },
  { value: 'Paris', label: '(GMT+01:00) Paris' },
  { value: 'Prague', label: '(GMT+01:00) Prague' },
  { value: 'Rome', label: '(GMT+01:00) Rome' },
  { value: 'Sarajevo', label: '(GMT+01:00) Sarajevo' },
  { value: 'Skopje', label: '(GMT+01:00) Skopje' },
  { value: 'Stockholm', label: '(GMT+01:00) Stockholm' },
  { value: 'Vienna', label: '(GMT+01:00) Vienna' },
  { value: 'Warsaw', label: '(GMT+01:00) Warsaw' },
  { value: 'West Central Africa', label: '(GMT+01:00) West Central Africa' },
  { value: 'Zagreb', label: '(GMT+01:00) Zagreb' },
  { value: 'Zurich', label: '(GMT+01:00) Zurich' },
  { value: 'Athens', label: '(GMT+02:00) Athens' },
  { value: 'Bucharest', label: '(GMT+02:00) Bucharest' },
  { value: 'Cairo', label: '(GMT+02:00) Cairo' },
  { value: 'Harare', label: '(GMT+02:00) Harare' },
  { value: 'Helsinki', label: '(GMT+02:00) Helsinki' },
  { value: 'Jerusalem', label: '(GMT+02:00) Jerusalem' },
  { value: 'Kaliningrad', label: '(GMT+02:00) Kaliningrad' },
  { value: 'Kyiv', label: '(GMT+02:00) Kyiv' },
  { value: 'Pretoria', label: '(GMT+02:00) Pretoria' },
  { value: 'Riga', label: '(GMT+02:00) Riga' },
  { value: 'Sofia', label: '(GMT+02:00) Sofia' },
  { value: 'Tallinn', label: '(GMT+02:00) Tallinn' },
  { value: 'Vilnius', label: '(GMT+02:00) Vilnius' },
  { value: 'Baghdad', label: '(GMT+03:00) Baghdad' },
  { value: 'Istanbul', label: '(GMT+03:00) Istanbul' },
  { value: 'Kuwait', label: '(GMT+03:00) Kuwait' },
  { value: 'Minsk', label: '(GMT+03:00) Minsk' },
  { value: 'Moscow', label: '(GMT+03:00) Moscow' },
  { value: 'Nairobi', label: '(GMT+03:00) Nairobi' },
  { value: 'Riyadh', label: '(GMT+03:00) Riyadh' },
  { value: 'St. Petersburg', label: '(GMT+03:00) St. Petersburg' },
  { value: 'Volgograd', label: '(GMT+03:00) Volgograd' },
  { value: 'Tehran', label: '(GMT+03:30) Tehran' },
  { value: 'Abu Dhabi', label: '(GMT+04:00) Abu Dhabi' },
  { value: 'Baku', label: '(GMT+04:00) Baku' },
  { value: 'Muscat', label: '(GMT+04:00) Muscat' },
  { value: 'Samara', label: '(GMT+04:00) Samara' },
  { value: 'Tbilisi', label: '(GMT+04:00) Tbilisi' },
  { value: 'Yerevan', label: '(GMT+04:00) Yerevan' },
  { value: 'Kabul', label: '(GMT+04:30) Kabul' },
  { value: 'Ekaterinburg', label: '(GMT+05:00) Ekaterinburg' },
  { value: 'Islamabad', label: '(GMT+05:00) Islamabad' },
  { value: 'Karachi', label: '(GMT+05:00) Karachi' },
  { value: 'Tashkent', label: '(GMT+05:00) Tashkent' },
  { value: 'Chennai', label: '(GMT+05:30) Chennai' },
  { value: 'Kolkata', label: '(GMT+05:30) Kolkata' },
  { value: 'Mumbai', label: '(GMT+05:30) Mumbai' },
  { value: 'New Delhi', label: '(GMT+05:30) New Delhi' },
  { value: 'Sri Jayawardenepura', label: '(GMT+05:30) Sri Jayawardenepura' },
  { value: 'Kathmandu', label: '(GMT+05:45) Kathmandu' },
  { value: 'Almaty', label: '(GMT+06:00) Almaty' },
  { value: 'Astana', label: '(GMT+06:00) Astana' },
  { value: 'Dhaka', label: '(GMT+06:00) Dhaka' },
  { value: 'Urumqi', label: '(GMT+06:00) Urumqi' },
  { value: 'Rangoon', label: '(GMT+06:30) Rangoon' },
  { value: 'Bangkok', label: '(GMT+07:00) Bangkok' },
  { value: 'Hanoi', label: '(GMT+07:00) Hanoi' },
  { value: 'Jakarta', label: '(GMT+07:00) Jakarta' },
  { value: 'Krasnoyarsk', label: '(GMT+07:00) Krasnoyarsk' },
  { value: 'Novosibirsk', label: '(GMT+07:00) Novosibirsk' },
  { value: 'Beijing', label: '(GMT+08:00) Beijing' },
  { value: 'Chongqing', label: '(GMT+08:00) Chongqing' },
  { value: 'Hong Kong', label: '(GMT+08:00) Hong Kong' },
  { value: 'Irkutsk', label: '(GMT+08:00) Irkutsk' },
  { value: 'Kuala Lumpur', label: '(GMT+08:00) Kuala Lumpur' },
  { value: 'Perth', label: '(GMT+08:00) Perth' },
  { value: 'Singapore', label: '(GMT+08:00) Singapore' },
  { value: 'Taipei', label: '(GMT+08:00) Taipei' },
  { value: 'Ulaanbaatar', label: '(GMT+08:00) Ulaanbaatar' },
  { value: 'Osaka', label: '(GMT+09:00) Osaka' },
  { value: 'Sapporo', label: '(GMT+09:00) Sapporo' },
  { value: 'Seoul', label: '(GMT+09:00) Seoul' },
  { value: 'Tokyo', label: '(GMT+09:00) Tokyo' },
  { value: 'Yakutsk', label: '(GMT+09:00) Yakutsk' },
  { value: 'Adelaide', label: '(GMT+09:30) Adelaide' },
  { value: 'Darwin', label: '(GMT+09:30) Darwin' },
  { value: 'Brisbane', label: '(GMT+10:00) Brisbane' },
  { value: 'Canberra', label: '(GMT+10:00) Canberra' },
  { value: 'Guam', label: '(GMT+10:00) Guam' },
  { value: 'Hobart', label: '(GMT+10:00) Hobart' },
  { value: 'Melbourne', label: '(GMT+10:00) Melbourne' },
  { value: 'Port Moresby', label: '(GMT+10:00) Port Moresby' },
  { value: 'Sydney', label: '(GMT+10:00) Sydney' },
  { value: 'Vladivostok', label: '(GMT+10:00) Vladivostok' },
  { value: 'Magadan', label: '(GMT+11:00) Magadan' },
  { value: 'New Caledonia', label: '(GMT+11:00) New Caledonia' },
  { value: 'Solomon Is.', label: '(GMT+11:00) Solomon Is.' },
  { value: 'Srednekolymsk', label: '(GMT+11:00) Srednekolymsk' },
  { value: 'Auckland', label: '(GMT+12:00) Auckland' },
  { value: 'Fiji', label: '(GMT+12:00) Fiji' },
  { value: 'Kamchatka', label: '(GMT+12:00) Kamchatka' },
  { value: 'Marshall Is.', label: '(GMT+12:00) Marshall Is.' },
  { value: 'Wellington', label: '(GMT+12:00) Wellington' },
  { value: 'Chatham Is.', label: '(GMT+12:45) Chatham Is.' },
  { value: 'Nuku\'alofa', label: '(GMT+13:00) Nuku\'alofa' },
  { value: 'Samoa', label: '(GMT+13:00) Samoa' },
  { value: 'Tokelau Is.', label: '(GMT+13:00) Tokelau Is.' }
];

// Detect user's timezone and find the best matching Rails timezone
const detectTimezone = () => {
  try {
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Map common IANA timezones to Rails timezone names
    const tzMapping = {
      'Asia/Ho_Chi_Minh': 'Hanoi',
      'Asia/Saigon': 'Hanoi',
      'Asia/Bangkok': 'Bangkok',
      'Asia/Jakarta': 'Jakarta',
      'Asia/Singapore': 'Singapore',
      'Asia/Tokyo': 'Tokyo',
      'Asia/Seoul': 'Seoul',
      'Asia/Shanghai': 'Beijing',
      'Asia/Hong_Kong': 'Hong Kong',
      'Australia/Sydney': 'Sydney',
      'Australia/Melbourne': 'Melbourne',
      'Europe/London': 'London',
      'Europe/Paris': 'Paris',
      'Europe/Berlin': 'Berlin',
      'America/New_York': 'Eastern Time (US & Canada)',
      'America/Chicago': 'Central Time (US & Canada)',
      'America/Denver': 'Mountain Time (US & Canada)',
      'America/Los_Angeles': 'Pacific Time (US & Canada)'
    };

    return tzMapping[browserTz] || 'Hanoi';
  } catch {
    return 'Hanoi';
  }
};

const STEPS = {
  PHONE: 'phone',
  FAMILY: 'family'
};

/**
 * NewFamilyApp - Multi-step form for phone number collection and family creation
 *
 * @param {Object} props
 * @param {string} props.locale - Locale for i18n (default: 'vi')
 * @param {string} props.railsEnv - Rails environment
 * @param {string} props.currentPhoneNumber - User's current phone number if any
 * @param {boolean} props.hasPhoneNumber - Whether user already has a valid phone number
 * @param {string} props.userName - User's name for pre-populating family name
 * @param {Function} props.onComplete - Callback when family creation is complete
 */
const NewFamilyApp = ({
  locale = 'vi',
  railsEnv,
  currentPhoneNumber = '',
  hasPhoneNumber = false,
  userName = '',
  onComplete
}) => {
  // Initialize i18n
  const i18nInitialized = useRef(false);
  if (!i18nInitialized.current) {
    initI18n(locale);
    i18nInitialized.current = true;
  }
  const { t } = useTranslation();

  const isTestMode = railsEnv === 'test' || railsEnv === 'development';

  // State
  const [currentStep, setCurrentStep] = useState(hasPhoneNumber ? STEPS.FAMILY : STEPS.PHONE);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Phone step state
  const [phoneNumber, setPhoneNumber] = useState(currentPhoneNumber);

  // Family step state - pre-populate with "Nhà {userName}" if userName is provided
  const [familyName, setFamilyName] = useState(userName ? `Nhà ${userName}` : '');
  const [timeZone, setTimeZone] = useState(detectTimezone());

  // Detect timezone on mount
  useEffect(() => {
    const detected = detectTimezone();
    setTimeZone(detected);
  }, []);

  const getCsrfToken = () => {
    return document.querySelector('meta[name="csrf-token"]')?.content || '';
  };

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!phoneNumber.trim()) {
      setError(t('newFamily.phone.errors.required'));
      return;
    }

    // Basic validation: 10-15 digits, optional + prefix
    const phoneRegex = /^\+?\d{10,15}$/;
    if (!phoneRegex.test(phoneNumber.replace(/\s/g, ''))) {
      setError(t('newFamily.phone.errors.invalid'));
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('/api/onboarding/phone_number', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken()
        },
        body: JSON.stringify({ phone_number: phoneNumber.replace(/\s/g, '') })
      });

      const data = await response.json();

      if (response.ok) {
        // Store success message to display on family step
        if (data.message) {
          setSuccessMessage(data.message);
        }
        setCurrentStep(STEPS.FAMILY);
      } else {
        setError(data.error || t('newFamily.phone.errors.saveFailed'));
      }
    } catch (err) {
      setError(t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  const handleFamilySubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!familyName.trim()) {
      setError(t('newFamily.family.errors.nameRequired'));
      return;
    }

    if (!timeZone) {
      setError(t('newFamily.family.errors.timezoneRequired'));
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('/api/onboarding/family', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken()
        },
        body: JSON.stringify({
          name: familyName,
          time_zone: timeZone
        })
      });

      const data = await response.json();

      if (response.ok) {
        onComplete?.(data);
        // Redirect to guardian dashboard
        window.location.href = data.redirect_url || '/guardian';
      } else {
        setError(data.error || t('newFamily.family.errors.createFailed'));
      }
    } catch (err) {
      setError(t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  const renderPhoneStep = () => (
    <div className="row justify-content-center">
      <div className="col-lg-6">
        <div className="card border rounded-3 shadow-sm">
          <div className="card-body p-5">
            {/* Icon and Header */}
            <div className="text-center mb-4">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                   style={{ width: '96px', height: '96px', background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="#16a34a" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                </svg>
              </div>
              <h2 className="h3 fw-bold mb-3">{t('newFamily.phone.title')}</h2>
              <p className="text-muted mb-0">
                {t('newFamily.phone.description')}
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handlePhoneSubmit} className="mt-4">
              {error && (
                <div className="alert alert-danger mb-4" role="alert">
                  {error}
                </div>
              )}

              <div className="mb-4">
                <label htmlFor="phone_number" className="form-label fw-semibold">
                  {t('newFamily.phone.label')}
                </label>
                <input
                  type="text"
                  id="phone_number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="form-control form-control-lg"
                  placeholder={t('newFamily.phone.placeholder')}
                  style={{ height: '50px', borderRadius: '8px' }}
                  disabled={loading}
                  {...(isTestMode && { 'data-testid': 'phone-input' })}
                />
                <div className="form-text">{t('newFamily.phone.help')}</div>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-lg text-white fw-semibold px-5 py-3"
                  style={{ background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)', borderRadius: '12px', border: 'none' }}
                  {...(isTestMode && { 'data-testid': 'phone-submit' })}
                >
                  {loading ? t('common.loading') : t('newFamily.phone.submit')}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Why We Need This Card */}
        <div className="card border rounded-3 shadow-sm mt-4">
          <div className="card-body p-4">
            <h3 className="h5 fw-bold mb-3">{t('newFamily.phone.whyWeNeed.title')}</h3>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex">
                <div className="d-flex align-items-center justify-content-center rounded-2 me-3 flex-shrink-0"
                     style={{ width: '32px', height: '32px', backgroundColor: '#dcfce7' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#16a34a" viewBox="0 0 16 16">
                    <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                    <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                  </svg>
                </div>
                <div>
                  <div className="fw-semibold small">{t('newFamily.phone.whyWeNeed.security.title')}</div>
                  <div className="text-muted" style={{ fontSize: '12px' }}>{t('newFamily.phone.whyWeNeed.security.description')}</div>
                </div>
              </div>
              <div className="d-flex">
                <div className="d-flex align-items-center justify-content-center rounded-2 me-3 flex-shrink-0"
                     style={{ width: '32px', height: '32px', backgroundColor: '#dbeafe' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#3b82f6" viewBox="0 0 16 16">
                    <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                  </svg>
                </div>
                <div>
                  <div className="fw-semibold small">{t('newFamily.phone.whyWeNeed.recovery.title')}</div>
                  <div className="text-muted" style={{ fontSize: '12px' }}>{t('newFamily.phone.whyWeNeed.recovery.description')}</div>
                </div>
              </div>
              <div className="d-flex">
                <div className="d-flex align-items-center justify-content-center rounded-2 me-3 flex-shrink-0"
                     style={{ width: '32px', height: '32px', backgroundColor: '#f3e8ff' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#9333ea" viewBox="0 0 16 16">
                    <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                  </svg>
                </div>
                <div>
                  <div className="fw-semibold small">{t('newFamily.phone.whyWeNeed.privacy.title')}</div>
                  <div className="text-muted" style={{ fontSize: '12px' }}>{t('newFamily.phone.whyWeNeed.privacy.description')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderFamilyStep = () => (
    <div className="row g-4">
      {/* Main Column - Family Creation Form */}
      <div className="col-lg-8">
        <div className="card border rounded-3 shadow-sm">
          <div className="card-body p-5">
            {/* Icon and Header */}
            <div className="text-center mb-4">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                   style={{ width: '96px', height: '96px', background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" fill="#3b82f6" viewBox="0 0 16 16">
                  <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                  <path fillRule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
                  <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                </svg>
              </div>
              <h2 className="h3 fw-bold mb-3">{t('newFamily.family.title')}</h2>
              <p className="text-muted mb-0">
                {t('newFamily.family.description')}
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handleFamilySubmit} className="mt-4">
              {successMessage && (
                <div className="alert alert-success mb-4" role="alert">
                  {successMessage}
                </div>
              )}
              {error && (
                <div className="alert alert-danger mb-4" role="alert">
                  {error}
                </div>
              )}

              <div className="mb-4">
                <label htmlFor="family_name" className="form-label fw-semibold">
                  {t('newFamily.family.nameLabel')}
                </label>
                <input
                  type="text"
                  id="family_name"
                  value={familyName}
                  onChange={(e) => setFamilyName(e.target.value)}
                  className="form-control form-control-lg"
                  placeholder={t('newFamily.family.namePlaceholder')}
                  style={{ height: '50px', borderRadius: '8px' }}
                  disabled={loading}
                  {...(isTestMode && { 'data-testid': 'family-name-input' })}
                />
              </div>

              <div className="mb-4">
                <label htmlFor="time_zone" className="form-label fw-semibold">
                  {t('newFamily.family.timezoneLabel')}
                </label>
                <select
                  id="time_zone"
                  value={timeZone}
                  onChange={(e) => setTimeZone(e.target.value)}
                  className="form-select form-select-lg"
                  style={{ height: '50px', borderRadius: '8px' }}
                  disabled={loading}
                  {...(isTestMode && { 'data-testid': 'timezone-select' })}
                >
                  {TIME_ZONES.map((tz) => (
                    <option key={tz.value} value={tz.value}>
                      {tz.label}
                    </option>
                  ))}
                </select>
                <div className="form-text">{t('newFamily.family.timezoneHelp')}</div>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-lg text-white fw-semibold px-5 py-3"
                  style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '12px', border: 'none' }}
                  {...(isTestMode && { 'data-testid': 'family-submit' })}
                >
                  {loading ? t('common.loading') : t('newFamily.family.submit')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Sidebar */}
      <div className="col-lg-4">
        {/* Getting Started Card */}
        <div className="card border-0 rounded-3 shadow-sm mb-4 text-white"
             style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <div className="card-body p-4">
            <h3 className="h5 fw-bold mb-3">{t('newFamily.family.gettingStarted.title')}</h3>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center justify-content-center rounded-circle me-3"
                     style={{ width: '24px', height: '24px', background: 'rgba(255, 255, 255, 0.2)' }}>
                  <span className="fw-bold" style={{ fontSize: '12px' }}>1</span>
                </div>
                <span>{t('newFamily.family.gettingStarted.step1')}</span>
              </div>
              <div className="d-flex align-items-center opacity-75">
                <div className="d-flex align-items-center justify-content-center rounded-circle me-3"
                     style={{ width: '24px', height: '24px', background: 'rgba(255, 255, 255, 0.2)' }}>
                  <span className="fw-bold" style={{ fontSize: '12px' }}>2</span>
                </div>
                <span>{t('newFamily.family.gettingStarted.step2')}</span>
              </div>
              <div className="d-flex align-items-center opacity-75">
                <div className="d-flex align-items-center justify-content-center rounded-circle me-3"
                     style={{ width: '24px', height: '24px', background: 'rgba(255, 255, 255, 0.2)' }}>
                  <span className="fw-bold" style={{ fontSize: '12px' }}>3</span>
                </div>
                <span>{t('newFamily.family.gettingStarted.step3')}</span>
              </div>
              <div className="d-flex align-items-center opacity-75">
                <div className="d-flex align-items-center justify-content-center rounded-circle me-3"
                     style={{ width: '24px', height: '24px', background: 'rgba(255, 255, 255, 0.2)' }}>
                  <span className="fw-bold" style={{ fontSize: '12px' }}>4</span>
                </div>
                <span>{t('newFamily.family.gettingStarted.step4')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* What You Can Do Card */}
        <div className="card border rounded-3 shadow-sm mb-4">
          <div className="card-body p-4">
            <h3 className="h5 fw-bold mb-3">{t('newFamily.family.whatYouCanDo.title')}</h3>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex">
                <div className="d-flex align-items-center justify-content-center rounded-2 me-3 flex-shrink-0"
                     style={{ width: '32px', height: '32px', backgroundColor: '#dcfce7' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#16a34a" viewBox="0 0 16 16">
                    <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                    <path fillRule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                  </svg>
                </div>
                <div>
                  <div className="fw-semibold small">{t('newFamily.family.whatYouCanDo.addChildren.title')}</div>
                  <div className="text-muted" style={{ fontSize: '12px' }}>{t('newFamily.family.whatYouCanDo.addChildren.description')}</div>
                </div>
              </div>
              <div className="d-flex">
                <div className="d-flex align-items-center justify-content-center rounded-2 me-3 flex-shrink-0"
                     style={{ width: '32px', height: '32px', backgroundColor: '#dbeafe' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#3b82f6" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M0 0h1v15h15v1H0V0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07z"/>
                  </svg>
                </div>
                <div>
                  <div className="fw-semibold small">{t('newFamily.family.whatYouCanDo.trackProgress.title')}</div>
                  <div className="text-muted" style={{ fontSize: '12px' }}>{t('newFamily.family.whatYouCanDo.trackProgress.description')}</div>
                </div>
              </div>
              <div className="d-flex">
                <div className="d-flex align-items-center justify-content-center rounded-2 me-3 flex-shrink-0"
                     style={{ width: '32px', height: '32px', backgroundColor: '#f3e8ff' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#9333ea" viewBox="0 0 16 16">
                    <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"/>
                    <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                  </svg>
                </div>
                <div>
                  <div className="fw-semibold small">{t('newFamily.family.whatYouCanDo.safeEnvironment.title')}</div>
                  <div className="text-muted" style={{ fontSize: '12px' }}>{t('newFamily.family.whatYouCanDo.safeEnvironment.description')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Need Help Card */}
        <NeedHelp t={t} />
      </div>
    </div>
  );

  return (
    <div className="bg-light min-vh-100">
      <div className="container py-4">
        {/* Page Header */}
        <div className="mb-4">
          <h1 className="display-6 fw-bold mb-2"
              {...(isTestMode && { 'data-testid': 'page-title' })}>
            {t('newFamily.welcomeTitle')}
          </h1>
          <p className="text-muted">
            {currentStep === STEPS.PHONE
              ? t('newFamily.phone.welcomeDescription')
              : t('newFamily.family.welcomeDescription')}
          </p>
        </div>

        {/* Step Content */}
        {currentStep === STEPS.PHONE ? renderPhoneStep() : renderFamilyStep()}
      </div>
    </div>
  );
};

export default NewFamilyApp;
